// test2671
(2671 && 0);
